/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable no-useless-return */
/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router-dom';
import useHalfSpace from 'components/hooks/useHalfSpace';
import useValidateMedia from 'components/hooks/useValidateMedia';
import MainCopyField from 'components/pages/ResourceSetting/Widgets/MainCopyField';
import CtaField from 'components/pages/ResourceSetting/Widgets/CtaField';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import TitleField from 'components/pages/ResourceSetting/Widgets/TitleField';
import ShortTitleField from 'components/pages/ResourceSetting/CPASDashboard/ShortTitleField';
import ProductRangeField from 'components/pages/ResourceSetting/Widgets/ProductRangeField';
import DescriptionField from 'components/pages/ResourceSetting/Widgets/DescriptionField';
import MediaField from 'components/pages/ResourceSetting/Widgets/MediaField';
import Ad, { ProductRanges, Statuses as AdStatuses } from 'models/business/Ad';
import Asset, { Categories as AssetCategories } from 'models/business/Asset';
import { Categories as PlatformCategories } from 'models/business/Platform';
import ActionButton from 'components/Common/ActionButton';
import HostingUrlField from 'components/pages/ResourceSetting/Widgets/HostingUrlField';
import HideableContainer from 'components/Common/HideableContainer';
import SaveChangePopup from 'components/pages/CreateAd/AdSetting/SaveChangePopup';
import API from 'api';
import classNames from 'classnames';
import ContentFeedField from '../ContentFeedField';
import Styles from './index.module.css';

export default function MainForm({
  ad,
  onChangeAd,
  // eslint-disable-next-line no-unused-vars
  firstEdit,
  onChangeMedia,
}) {
  const history = useHistory();
  const [productRange, setProductRange] = useState(ProductRanges.Total);
  const [saveChangePopupStatus, setSaveChangePopupStatus] = useState(0);
  const [popupAction, setPopupAction] = useState();
  const [isAdSaved, setIsAdSaved] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const { validateImage, validateSquareImageRange, validateVideoRatio } = useValidateMedia();
  const { restrictByHalfSpace, halfSpaceLength } = useHalfSpace();
  const [original, setOriginal] = useState({
    ad: new Ad(),
    media: {},
  });
  const [media, _setMedia] = useState({
    prepopulated: null,
    local: null,
  });
  const [contentFeed, setContentFeed] = useState({
    prepopulated: null,
    local: null,
  });
  const setMedia = useMemo(() => (m) => {
    _setMedia(m);
    onChangeMedia(m);
  }, [_setMedia]);

  const hasUnsavedChanges = useMemo(() => (
    !original.ad.equals(ad) || original.media !== media || original.contentFeed !== contentFeed
  ), [ad, original, media, contentFeed]);

  const deleteAllMedia = async (categories = [AssetCategories.Media, AssetCategories.ContentFeed]) => {
    const deletionPromises = [];
    ad.assets.forEach((asset) => {
      if (categories.includes(asset.category)) {
        deletionPromises.push(API.ad.deleteAdMedia(asset.id));
      }
    });

    return Promise.allSettled(deletionPromises);
  };

  // const deleteAllMedia = async () => {
  //   const deletionPromises = [];
  //   ad.assets.forEach((asset) => {
  //     if (asset.category === AssetCategories.Media) {
  //       deletionPromises.push(API.ad.deleteAdMedia(asset.id));
  //     }
  //   });

  //   return Promise.allSettled(deletionPromises);
  // };

  const uploadFile = async (file, category) => API.ad.postAdMedia(ad.id, category, file);

  // const handleChangeField = (e, field, length) => {
  //   const newAd = ad.clone();
  //   const value = length ? restrictByHalfSpace(e.target.value, length, newAd[field]) : e.target.value;
  //   // if (field === 'mainCopy') {
  //   //   const rowLimit = 3;
  //   //   const lines = value.split(/\n/);
  //   //   if (lines.length > rowLimit) {
  //   //     value = lines.slice(0, rowLimit).join('\n');
  //   //   }
  //   // }
  //   newAd[field] = value;
  //   onChangeAd(newAd);
  // };

  const handleChangeField = (e, field, length) => {
    const newAd = ad.clone();
    if (halfSpaceLength(e.target.value) > length) {
      alert(`輸入文字超過長度上限(${length})`);
    }
    const value = length ? restrictByHalfSpace(e.target.value, length, newAd[field]) : e.target.value;
    newAd[field] = value;
    onChangeAd(newAd);
  };

  const saveAd = async () => {
    if (!hasUnsavedChanges) return true;
    setIsAdSaved(false);
    let newOriginalMedia = original.media;
    let newOriginalContent = original.contentFeed;
    // const clearAdMedia = () => {
    //   const newMedia = {
    //     prepopulated: null,
    //     local: null,
    //   };
    //   setMedia(newMedia);
    //   newOriginalMedia = newMedia;
    //   const newAd = ad.clone();
    //   newAd.assets = [];
    //   onChangeAd(newAd);
    // };
    const clearAdAssets = (categories = []) => {
      if (categories.includes(AssetCategories.Media)) {
        const newMedia = {
          prepopulated: null,
          local: null,
        };
        setMedia(newMedia);
        newOriginalMedia = newMedia;
      }
      if (categories.includes(AssetCategories.ContentFeed)) {
        const newContentFeed = {
          prepopulated: null,
          local: null,
        };
        setContentFeed(newContentFeed);
        newOriginalContent = newContentFeed;
      }
      const newAd = ad.clone();
      newAd.assets = [...newAd.assets].filter((a) => !categories.includes(a));
      onChangeAd(newAd);
      return newAd;
    };

    const deletionCategories = [];
    // if (!media.prepopulated) deletionCategories.push(AssetCategories.Media);
    if (!contentFeed.prepopulated || productRange === ProductRanges.Total) deletionCategories.push(AssetCategories.ContentFeed);
    await deleteAllMedia(deletionCategories);

    const localDeletionCategories = [];
    if (!media.local && !media.prepopulated) localDeletionCategories.push(AssetCategories.Media);
    if ((!contentFeed.local && !contentFeed.prepopulated)) localDeletionCategories.push(AssetCategories.ContentFeed);
    const newAd = clearAdAssets(localDeletionCategories);

    const newAssets = [];

    if (ad.platform === PlatformCategories.FacebookCarousel) {
      await deleteAllMedia([AssetCategories.Media]);
      // clearAdMedia();
      clearAdAssets([AssetCategories.Media]);
    }

    if (ad.platform === PlatformCategories.FacebookFeatured
      || ad.platform === PlatformCategories.FacebookReferral
      || ad.platform === PlatformCategories.FacebookImpression) {
      if (!media.prepopulated) {
        await deleteAllMedia([AssetCategories.Media]);
        if (!media.local) {
          // clearAdMedia();
          clearAdAssets([AssetCategories.Media]);
        }
      }
      if (media.local) {
        const result = await uploadFile(media.local, AssetCategories.Media);
        if (!result.error) {
          const newMedia = {
            prepopulated: new Asset(result.resultData),
            local: null,
          };
          setMedia(newMedia);
          newOriginalMedia = newMedia;
          // const newAd = ad.clone();
          newAssets.push(new Asset(result.resultData));
          // newAd.injectAssets([new Asset(result.resultData)]);
          // onChangeAd(newAd);
        }
      }
    }

    if (contentFeed.local) {
      const result = await uploadFile(contentFeed.local, AssetCategories.ContentFeed);
      if (!result.error) {
        const newContentFeed = {
          prepopulated: new Asset(result.resultData),
          local: null,
        };
        setContentFeed(newContentFeed);
        newOriginalContent = newContentFeed;
        newAssets.push(new Asset(result.resultData));
      }
    } else if (contentFeed.prepopulated && ad.contentFeedCategory !== AssetCategories.MarketContentFeed) {
      newAssets.push(new Asset(contentFeed.prepopulated));
    }

    // const newAd = ad.clone();
    const preStatus = newAd.status;
    newAd.status = AdStatuses.Incomplete;

    newAd.injectAssets(newAssets);
    onChangeAd(newAd);

    // const result = await API.ad.postUpdateAd(newAd.toJSON());
    const result = await API.ad.postUpdateAd2(newAd.toJSON());
    if (result.error) {
      alert(result.error.errorMsg);
      setIsAdSaved(true);
      return null;
    }
    setOriginal({
      ad: newAd,
      media: newOriginalMedia,
      contentFeed: newOriginalContent,
    });
    setIsAdSaved(true);
    if (ad.valid
        && (ad.platform === PlatformCategories.FacebookCarousel
          || (ad.platform === PlatformCategories.FacebookFeatured && (media?.prepopulated || media?.local))
          || (ad.platform === PlatformCategories.FacebookReferral && (media?.prepopulated || media?.local))
          || (ad.platform === PlatformCategories.FacebookImpression && (media?.prepopulated || media?.local)))
        && !(
          (ad.platform === PlatformCategories.FacebookCarousel || ad.platform === PlatformCategories.FacebookFeatured)
            && ad.contentFeedCategory === AssetCategories.ContentFeed
            && !(contentFeed.local || contentFeed.prepopulated)
        )) {
      if (preStatus === AdStatuses.Incomplete) {
        setSaveChangePopupStatus(0);
      }
      if (preStatus === AdStatuses.Pending || preStatus === AdStatuses.Online) {
        setSaveChangePopupStatus(2);
      }
      setPopupAction(true);
    } else if (preStatus === AdStatuses.Pending || preStatus === AdStatuses.Online) {
      setSaveChangePopupStatus(1);
      setPopupAction(true);
    }
    return true;
  };

  const submitAd = async () => {
    // setPopupAction(true);
    saveAd().then((ok) => ok && popupAction && history.push('/MyAds'));
    // saveAd().then((ok) => ok && history.push('/MyAds'));
  };

  useEffect(() => {
    if (!firstLoad || !ad.id) return;
    setFirstLoad(false);
    const originalAd = ad;
    let originalMedia = media;
    let originalContent = contentFeed;
    const mediaAsset = ad.assets.find((a) => a.category === AssetCategories.Media);
    if (mediaAsset) {
      const newMedia = {
        prepopulated: mediaAsset,
        local: null,
      };
      setMedia(newMedia);
      originalMedia = newMedia;
    }
    const contentAsset = ad.assets.find((a) => a.category === AssetCategories.ContentFeed);
    if (contentAsset) {
      const newContentFeed = {
        prepopulated: contentAsset,
        local: null,
      };
      setContentFeed(newContentFeed);
      originalContent = newContentFeed;
      setProductRange(ProductRanges.Selected);
    }
    setOriginal({
      ad: originalAd,
      media: originalMedia,
      contentFeed: originalContent,
    });
  }, [ad]);

  const carouselMode = ad.platform === PlatformCategories.FacebookCarousel;
  const featuredMode = ad.platform === PlatformCategories.FacebookFeatured;
  const referralMode = ad.platform === PlatformCategories.FacebookReferral;
  const impressionMode = ad.platform === PlatformCategories.FacebookImpression;

  return (
    <Box
      display="flex"
      flexDirection="column"
      style={{ position: 'relative' }}
    >
      <Box marginBottom={3}>
        <MainCopyField
          value={ad.mainCopy}
          onChange={(e) => handleChangeField(e, 'mainCopy')}
          placeholder={`(文案範例預覽)
歡慶新年🎊New Balance品牌週🎊
【勁爆下殺全館５折起🔥】
新年穿新鞋！立刻下單去🛒https://lihi1.com/lxTq9

▼▼熱銷款限時超低價！超多優惠報你知▼▼
✨百搭復古運動鞋 #M5740TA 限搶價$４２８０
✨率性戶外慢跑鞋 #MTNTRMB4 下殺 $１９８４
✨熱銷系列玩轉新色 #ML373CO2 下殺$１６６６
✨必備經典復古 #ML574NR2 下殺$２１６０
日常時尚鞋款應有盡有😍一雙NB陪你歡喜迎新年 !

數量有限，售完為止`}
        />
      </Box>
      <HideableContainer hidden={!carouselMode}>
        <Box marginBottom={3}>
          <CtaField value={ad.cta} onChange={(e) => handleChangeField(e, 'cta')} />
        </Box>
      </HideableContainer>
      <HideableContainer hidden={!featuredMode && !referralMode}>
        <Box marginBottom={3}>
          {/* <TitleField value={ad.title} onChange={(e) => handleChangeField(e, 'title', 40)} /> */}
          <FormLabel
            title="廣告標題"
            description="限40個半形文字"
            disabled={false}
            required={true}
          />
          <ShortTitleField
            value={ad.title}
            onChange={(e) => handleChangeField(e, 'title', 40)}
            placeholder="歡慶新年🎊NB品牌週全館下殺５折起 !"
          />
          <div className={classNames(Styles.cntTextLength)}>
            {`${halfSpaceLength(ad.title)} / 40`}
          </div>
        </Box>
      </HideableContainer>
      <HideableContainer hidden={!featuredMode}>
        <Box marginBottom={3}>
          {/* <DescriptionField value={ad.description} onChange={(e) => handleChangeField(e, 'description', 40)} /> */}
          <FormLabel
            title="標題敘述"
            description="限40個半形文字"
            disabled={false}
            required={true}
          />
          <ShortTitleField
            value={ad.description}
            onChange={(e) => handleChangeField(e, 'description', 40)}
            placeholder="(未顯示於預覽圖中)NB全館優惠中✨逛全館"
          />
          <div className={classNames(Styles.cntTextLength)}>
            {`${halfSpaceLength(ad.description)} / 40`}
          </div>
        </Box>
      </HideableContainer>
      <Box marginBottom={3}>
        <HostingUrlField required value={ad.hostingUrl} onChange={(e) => handleChangeField(e, 'hostingUrl')} />
      </Box>
      <HideableContainer hidden={carouselMode}>
        <Box marginBottom={3}>
          <MediaField
            value={(media.local ?? media.prepopulated ?? {}).name}
            onChange={async (file) => {
              if (file) {
                let valid = await validateSquareImageRange(file, 1080, 2400, false, 5 * 1024 * 1024);
                if (!valid) valid = await validateVideoRatio(file, 16, 9, false, 100 * 1024 * 1024);
                if (!valid) valid = await validateVideoRatio(file, 1, 1, false, 100 * 1024 * 1024);
                if (!valid) {
                  alert('您上傳的檔案不符合格式及大小，請重新上傳');
                  return;
                }
              }

              setMedia({
                prepopulated: null,
                local: file,
              });
            }}
          />
        </Box>
      </HideableContainer>
      <Box
        marginBottom={3}
        hidden={(
          (ad.platform === PlatformCategories.FacebookReferral)
          || (ad.platform === PlatformCategories.FacebookImpression)
        )}
      >
        <ProductRangeField
          value={productRange}
          onChange={(range) => {
            let newContentFeedCategory = AssetCategories.ContentFeed;
            if (range === ProductRanges.Total) {
              newContentFeedCategory = AssetCategories.MarketContentFeed;
            }
            setProductRange(range);

            const newAd = ad.clone();
            newAd.contentFeedCategory = newContentFeedCategory;
            onChangeAd(newAd);
          }}
          contentFeed={contentFeed}
          setContentFeed={() => setContentFeed({
            prepopulated: null,
            local: null,
          })}
        />
      </Box>
      <HideableContainer hidden={productRange !== ProductRanges.Selected}>
        <Box marginBottom={3}>
          <ContentFeedField
            value={(contentFeed.local ?? contentFeed.prepopulated ?? {}).name}
            onChange={(file) => {
              setContentFeed({
                prepopulated: null,
                local: file,
              });
            }}
          />
        </Box>
      </HideableContainer>
      <div className={Styles.formButtons}>
        <ActionButton onClick={saveAd} disabled={!hasUnsavedChanges}>
          儲存進度
        </ActionButton>
        <ActionButton style={{ color: '#FFFFFF' }} onClick={() => history.push('/MyAds')}>
          {firstEdit ? '返回我的廣告' : '取消'}
          {/* 取消 */}
        </ActionButton>
        <ActionButton
          style={{ color: '#FFFFFF' }}
          disabled={(
            !ad.valid
            || (ad.platform === PlatformCategories.FacebookCarousel && !(media?.prepopulated || media?.local))
            || (ad.platform === PlatformCategories.FacebookFeatured && !(media?.prepopulated || media?.local))
            || (ad.platform === PlatformCategories.FacebookReferral && !(media?.prepopulated || media?.local))
            || (ad.platform === PlatformCategories.FacebookImpression && !(media?.prepopulated || media?.local))
            || (
              (ad.platform === PlatformCategories.FacebookCarousel || ad.platform === PlatformCategories.FacebookFeatured)
              && ad.contentFeedCategory === AssetCategories.ContentFeed && !(contentFeed.local || contentFeed.prepopulated)
            )
            || !isAdSaved
            || !hasUnsavedChanges
          )}
          onClick={submitAd}
        >
          完成
        </ActionButton>
        {popupAction && <SaveChangePopup status={saveChangePopupStatus} onClose={() => { setPopupAction(); submitAd(); }} />}
      </div>
    </Box>
  );
}

MainForm.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
  firstEdit: PropTypes.bool,
  onChangeMedia: PropTypes.func,
};

MainForm.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => { },
  firstEdit: false,
  onChangeMedia: () => { },
};
